import React, { useState, useEffect } from "react";
import "./Orders.css";
import { useLocation } from "react-router-dom";
import { IoSearch } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Orders = ({ orders }) => {
  const [isFocused, setIsFocused] = useState(false);
  const location = useLocation();
  const [searchno, setsearchno] = useState("");

  const navigate = useNavigate();

  const handlesearch = (e) => {
    e.preventDefault();

    const trimmed = searchno.trim();

    if (!trimmed) {
      console.warn("Empty search value");
      return;
    }

    const result = orders.filter(
      (item) =>
        String(item.tracking_number).replace(/^#/, "") ===
        String(trimmed).replace(/^#/, "")
    );

    console.log("Search for:", trimmed, "Results:", result);

    if (result.length > 0) {
      const raw = result[0].tracking_number;
      const cleanTracking = raw.startsWith("#") ? raw.slice(1) : raw;

      navigate(`orders/orderid/${cleanTracking}`, {
        state: { order: result[0] },
      });
    } else {
      console.warn("Order not found");
    }
  };

  useEffect(() => {
    console.log("Loaded orders:", orders);
  }, [orders]);

  const [isOrderMsg, setisOrderMsg] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [updateMsg, setUpdateMsg] = useState("");
  const [SelectedOrderId, setSelectedOrderId] = useState("");
  const [ExpandRow, setExpandRow] = useState(null)
  const [openSections, setOpenSections] = useState({});

  const handleRowClick = (orderId) => {
    setExpandRow(prev => (prev === orderId ? null : orderId));
    setOpenSections(prev => ({
      ...prev,
      [orderId]: {
        customer: false,
        order: true,
        payment: false
      }
    }));
  }
  const toggleSection = (orderId, section) => {
    setOpenSections(prev => ({
      ...prev,
      [orderId]: {
        ...prev[orderId],
        [section]: !prev[orderId]?.[section]
      }
    }));
  };


  const handleOrderUpdate = (id) => {
    setSelectedOrderId(id)
    setisOrderMsg((pv) => !pv)
  }

  const handleUpdateOrder = async () => {

    if (!updateMsg) {
      toast.error("Enter the Remarks before update the order")
      return
    }

    try {
      setUpdateLoading(true)
      const formData = new FormData();
      formData.append("order_id", SelectedOrderId);
      formData.append("message", updateMsg);

      const res = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/order_update.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await res.json();
      if (data.status === "success") {
        setUpdateMsg("")
        setSelectedOrderId("")
        setisOrderMsg((pv) => !pv)
        toast.success("order updated successfully")
      } else {
        toast.error(data.message || "Failed to update password.");
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error("Something went wrong.");
    } finally {
      setUpdateLoading(false)
    }
  }

  return (
    <div>
      {location.pathname === "/vendor/orders" ? (
        <h1 className="dashboard-heading">New Orders</h1>
      ) : location.pathname === "/vendor/vendordashboard" ? (
        <div className="report-title">📋 Order Reports</div>
      ) : null}

      {location.pathname !== "/vendor/vendordashboard" && (
        <form className="glow-search-container" onSubmit={handlesearch}>
          <input
            type="text"
            className="glow-search-input"
            placeholder="Find your Orders, fast..."
            value={searchno}
            onChange={(e) => setsearchno(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
          <span
            className={`search-icon ${isFocused ? "animate" : ""}`}
            onClick={handlesearch}
          >
            <IoSearch />
          </span>
        </form>
      )}

      <div
        className="report-container"
        style={{
          background:
            location.pathname === "/vendor/vendordashboard"
              ? "#f9f9ff"
              : "transparent",
        }}
      >
        <table className="report-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Order ID</th>
              <th>Customer Name</th>
              <th>Date</th>
              <th>Address</th>
              <th>Total Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((item, index) => (
              <React.Fragment key={item.order_id}>
                {/* Main Row */}
                <tr onClick={() => handleRowClick(item.order_id)}>
                  <td>{index + 1}</td>
                  <td>{item.tracking_number}</td>
                  <td>{item.cust_name}</td>
                  <td>{item.order_date}</td>
                  <td>{item.ship_add}</td>
                  <td>{item.total_amount}</td>
                  <td>
                    <span
                      className={`status ${item.order_status
                        .toLowerCase()
                        .replace(" ", "-")}`}
                    >
                      {item.order_status}
                    </span>
                  </td>
                </tr>

                {/* Expanded Row */}
                {ExpandRow === item.order_id && (
                  <tr className="expanded-row">
                    <td colSpan="8">
                      <div className="expanded-wrapper">

                        {/* 1. Customer Details (default closed) */}
                        <div className="exp-section">
                          <div
                            className="exp-title"
                            onClick={() => toggleSection(item.order_id, "customer")}
                          >
                            Customer Details
                            <span className="exp-arrow">▾</span>
                          </div>

                          {openSections[item.order_id]?.customer && (
                            <div className="exp-body">
                              <p><b>Name:</b> {item.cust_name}</p>
                              <p><b>Phone:</b> {item.phone_no}</p>
                              <p><b>Email:</b> {item.email}</p>
                              <p><b>Address:</b> {item.ship_add}</p>
                            </div>
                          )}
                        </div>

                        {/* 2. Order Details (default OPEN) */}
                        <div className="exp-section">
                          <div
                            className="exp-title"
                            onClick={() => toggleSection(item.order_id, "order")}
                          >
                            Order Details
                            <span className="exp-arrow">▾</span>
                          </div>

                          {openSections[item.order_id]?.order && (
                            <>
                              <div className="exp-body">
                                <p>Order Status: <span
                                  className={`status ${item.order_status
                                    .toLowerCase()
                                    .replace(" ", "-")}`}
                                >
                                  {item.order_status}
                                </span>
                                </p>
                                {item.products.map((p, i) => (
                                  <>
                                    <div key={i} className="product-row">
                                      <p><b>{p.prod_name}</b> x {p.quantity}</p>
                                      <p>Price: ₹{p.price}</p>
                                    </div>
                                  </>
                                ))}

                                <button
                                  className="search-btn"
                                  style={{ marginBottom: "8px" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOrderUpdate(item.tracking_number);
                                  }}
                                >
                                  order update
                                </button>
                              </div>

                            </>)}
                        </div>

                        {/* 3. Payment Details (default closed) */}
                        <div className="exp-section">
                          <div
                            className="exp-title"
                            onClick={() => toggleSection(item.order_id, "payment")}
                          >
                            Payment Details
                            <span className="exp-arrow">▾</span>
                          </div>

                          {openSections[item.order_id]?.payment && (
                            <div className="exp-body">
                              <p><b>Status:</b> {item.payment_status}</p>
                              <p><b>Method:</b> {item.payment_method}</p>
                              <p><b>Cancel Reason:</b> {item.cancel_reason || "—"}</p>
                              <p><b>Delivery Date:</b> {item.delivery_date || "—"}</p>
                            </div>
                          )}
                        </div>

                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>

        {isOrderMsg && (
          <div className="modal-overlay">
            <div className="modal-box" style={{ maxWidth: "500px" }}>
              <h3>Update Order</h3>

              <div className="row" style={{ textAlign: "start", width: "100%", gap: "8px" }} >
                <label>Message</label>
                <textarea
                  rows={5}
                  placeholder="Enter your message..."
                  value={updateMsg}
                  onChange={(e) => setUpdateMsg(e.target.value)}
                />
              </div>

              <div className="confirm-buttons">
                <button
                  className="no-btn"
                  onClick={handleUpdateOrder}
                  disabled={updateLoading ? true : false}
                >
                  Update
                </button>

                <button
                  className="yes-btn"
                  onClick={handleOrderUpdate}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>

        )}
      </div>
    </div>
  );
};

export default Orders;
